import { easeInOut, motion, MotionValue, useMotionValueEvent, useScroll, useTransform, type TransformOptions } from "motion/react";
import { useRef } from "react";
import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import PopIn from "../animations/PopIn";
import ProgrammerPlayground from "../ProgrammerPlayground/ProgrammerPlayground";
import LettersPullDown from "../animations/LettersPullDown";
import { AnimatedSectionsHeading } from "./AnimatedSectionsHeading";

export default function HobbyistSection({ scrollOffset = 0, className }: { scrollOffset?: number; className?: string }) {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({ target: container, offset: ["start end", "end end"] }); // Progress of the about section filling the user's viewport
  const sceneStartTransition = useTransform(scrollYProgress, [0.14, 0.36], [0, 1], { ease: easeInOut });
  const titleExpandProgress = useTransform(sceneStartTransition, [0, 0.55, 1], [0, 0, 100]);
  const firstExpandWidth = useTransform(titleExpandProgress, [0, 16.1], ["0%", "100%"]);
  const secondExpandWidth = useTransform(titleExpandProgress, [16.1, 100], ["0%", "100%"]);

  const playgroundScene = useTransform(scrollYProgress, [0.288, 0.848], [0, 1]);
  const sceneEndTransition = useTransform(scrollYProgress, [0.86, 1], [0, 1]);

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    // console.log({ latest });
  });

  return (
    <ScrollAnimContext.Provider value={scrollYProgress}>
      <motion.div style={{ height: "500svh", marginTop: "-90svh" }} className='w-full bg-black text-neutral-100' ref={container}>
        <div style={{ height: "100svh" }} className='sticky top-0 flex flex-col justify-center items-center w-full'>
          <AnimatedSectionsHeading className='text-2xl/snug'>
            {/* "I'm a hobbyist turned programmer" title */}
            <motion.div className='flex items-center justify-center flex-wrap xl:flex-nowrap'>
              <div className='flex justify-center'>
                <motion.div className='shrink-0'>
                  <PopIn scrollProgress={sceneStartTransition}>
                    <LettersPullDown text='I' length={32} scrollProgress={sceneEndTransition} />
                  </PopIn>
                </motion.div>

                <motion.div style={{ width: firstExpandWidth }} className='overflow-hidden whitespace-pre'>
                  <LettersPullDown text="'m a " length={32} index={1} scrollProgress={sceneEndTransition} />
                </motion.div>
              </div>
              <motion.div style={{ width: secondExpandWidth }} className='flex justify-center'>
                <div className='overflow-hidden whitespace-pre w-fit'>
                  <LettersPullDown text='hobbyist-turned-programmer' length={32} index={5} scrollProgress={sceneEndTransition} />
                </div>
              </motion.div>
            </motion.div>
          </AnimatedSectionsHeading>
          <div className='absolute -z-20 h-full w-full'>
            <ScrollAnimContext.Provider value={playgroundScene}>
              <ProgrammerPlayground />
            </ScrollAnimContext.Provider>
          </div>
        </div>
      </motion.div>
    </ScrollAnimContext.Provider>
  );
}
